import { createSelector } from 'reselect';
import type { RootState } from '@/app/store';

export const selectAuth = (state: RootState): RootState['auth'] => state.auth;
export const selectCurrentUser = createSelector(selectAuth, (auth) => auth.user);
export const selectIsAuthenticated = createSelector(selectAuth, (auth) => Boolean(auth.token));
export const selectAuthStatus = createSelector(selectAuth, (auth) => auth.status);
export const selectAuthError = createSelector(selectAuth, (auth) => auth.error);
export const selectUserRole = createSelector(selectCurrentUser, (user) => user?.role ?? null);
